import { render, staticRenderFns } from "./EditUserPopup.vue?vue&type=template&id=04beb3fa&"
import script from "./EditUserPopup.vue?vue&type=script&lang=ts&"
export * from "./EditUserPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04beb3fa')) {
      api.createRecord('04beb3fa', component.options)
    } else {
      api.reload('04beb3fa', component.options)
    }
    module.hot.accept("./EditUserPopup.vue?vue&type=template&id=04beb3fa&", function () {
      api.rerender('04beb3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EditUserPopup.vue"
export default component.exports